/**
 * Timber Pricing Types
 * For managing timber pricing data stored in Firestore
 */

export interface TimberPriceEntry {
  width: number;        // inches
  height: number;       // inches
  length: number;       // feet (will be converted to inches internally)
  pricePerPiece: number;
}

export interface TimberPricingData {
  id: string;           // e.g., 'douglas-fir'
  name: string;         // e.g., 'Douglas Fir'
  species: string;      // e.g., 'DF'
  entries: TimberPriceEntry[];
  lastUpdated: Date;
  uploadedBy: string;
  fileName?: string;    // Original CSV filename
}

export type TimberSpecies = 'douglas-fir' | 'western-red-cedar' | 'hemlock-fir' | 'spruce-pine-fir' | 'southern-yellow-pine';

export const TIMBER_SPECIES_INFO: Record<TimberSpecies, { name: string; abbrev: string; aliases: string[] }> = {
  'douglas-fir': {
    name: 'Douglas Fir',
    abbrev: 'DF',
    aliases: ['DF', 'Doug Fir', 'Douglas Fir', 'douglas fir', 'doug fir'],
  },
  'western-red-cedar': {
    name: 'Western Red Cedar',
    abbrev: 'WRC',
    aliases: ['WRC', 'Western Red Cedar', 'Red Cedar', 'western red cedar'],
  },
  'hemlock-fir': {
    name: 'Hemlock Fir',
    abbrev: 'HF',
    aliases: ['HF', 'Hemlock', 'Hemlock Fir', 'hemlock fir'],
  },
  'spruce-pine-fir': {
    name: 'Spruce Pine Fir',
    abbrev: 'SPF',
    aliases: ['SPF', 'Spruce Pine Fir', 'spruce pine fir'],
  },
  'southern-yellow-pine': {
    name: 'Southern Yellow Pine',
    abbrev: 'SYP',
    aliases: ['SYP', 'Southern Yellow Pine', 'Yellow Pine', 'southern yellow pine'],
  },
};
